import type { RootState } from 'app/store';

export function restoreSessionUi(
  current: RootState,
  merged: RootState
): RootState {
  return {
    ...merged,
    ui: {
      ...merged.ui,
      googleApiLoaded: current.ui.googleApiLoaded,
      reproducingErrorLogId: current.ui.reproducingErrorLogId
    }
  };
}
